import React, { useEffect, useRef, useState } from "react";



import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

import banner1 from "../img/banner1.jpg";
import banner2 from "../img/banner2.jpg";
import banner3 from "../img/banner3.jpg";

const slides = [
  {
    image: banner3,
    title: "Digital Transformation",
    description: "Transforms businesses with intelligent digital solutions.",
  },
  {
    image: banner2,
    title: "Innovative Technology",
    description: "Smart Innovation for a Smarter Tech World.",
  },
  {
    image: banner1,
    title: "Software Development Company",
    description: "High-quality software, IT & SaaS solutions.",
  },
];

const DELAY = 6000;


const Carousel = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);
  const isPaused = useRef(false);
  const hasInteracted = useRef(false);

  const nextSlide = () => {
    setCurrent((p) => (p + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((p) => (p - 1 + slides.length) % slides.length);
  };

  // Autoplay
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (!isPaused.current) {
        nextSlide();
      }
    }, DELAY);

    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <div
      className="relative w-full h-[600px] overflow-hidden"
      onMouseEnter={() => {
        if (hasInteracted.current) isPaused.current = true;
      }}
      onMouseLeave={() => {
        hasInteracted.current = true;
        isPaused.current = false;
      }}
    >
      {/* Background */}
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${slides[current].image})` }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="absolute inset-0 bg-black/60" />
        </motion.div>
      </AnimatePresence>

      {/* Content */}
      <div className="absolute inset-0 flex items-center px-6 md:px-24 z-10">
        <div className="max-w-xl text-white">
          <motion.h1
            key={slides[current].title}
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -30, opacity: 0 }}
            className="text-4xl md:text-6xl font-bold mb-4"
          >
            {slides[current].title}
          </motion.h1>

          <motion.p
            key={slides[current].description}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            className="text-gray-200 mb-8"
          >
            {slides[current].description}
          </motion.p>

         <button
  onClick={() => navigate("/contact-us")}
  className="bg-indigo-700 px-8 py-3 rounded-md"
>
  Contact Us
</button>

        </div>
      </div>

      {/* 🔘 Navigation Buttons */}
      <button
        onClick={() => {
          hasInteracted.current = true;
          prevSlide();
        }}
        className="absolute left-5 top-1/2 -translate-y-1/2 z-20 bg-black/40 hover:bg-black/60 text-white p-3 rounded-full"
      >
        ❮
      </button>

      <button
        onClick={() => {
          hasInteracted.current = true;
          nextSlide();
        }}
        className="absolute right-5 top-1/2 -translate-y-1/2 z-20 bg-black/40 hover:bg-black/60 text-white p-3 rounded-full"
      >
        ❯
      </button>
    </div>
  );
};

export default Carousel;
